<template>
    <div>

      <div style="margin-bottom: 10px;" v-if="showUpload">{{'changeProfileImageInstructions' | lang}} </div>
      
      <div class="wrapper-img">

        <div>
        <!--div class="line"></div-->
        <croppa v-if="initialized" v-model="myCroppa"
            :width="width"
            :height="height" 
            initial-size="contain"  
            placeholder=" "
            :quality="quality"
            accept="image/jpeg,image/png"
            :placeholder-font-size="0"
            :disabled="false"
            :show-loading="false"
            :prevent-white-space="true"
            :show-remove-button="true"
            @file-type-mismatch="handleCroppaFileTypeMismatch"
            @file-choose="handleCroppaFileChoose" 
            @image-remove="handleImageRemove"
            @move="handleCroppaMove"
            @zoom="handleCroppaZoom">  
            <img v-if="image" slot="placeholder" :src="image">
            <img v-if="!image" slot="placeholder" src="@/assets/icons/user_pad.svg">
            <div class="spinner" v-if="myCroppa && myCroppa.loading"></div>
            
          <!--  <img crossOrigin="anonymous" :src="image"
             slot="initial">  -->  
      </croppa>
      <div v-if="!showUpload" class="placeholder-img">{{'changeProfileImage' | lang}}</div>
      </div>
  
    </div>
    <div class="croppa-operations">
    <button class="margin-operations-buttons" v-if="showUpload" @click="myCroppa.rotate()"><i  class="fa fa-fw fa-rotate-right"></i></button>
    <button class="margin-operations-buttons" v-if="showUpload" @click="myCroppa.rotate(-1)"><i  class="fa fa-fw fa-rotate-left"></i></button>
    <button  class="margin-operations-buttons" v-if="showUpload" @click="myCroppa.zoomIn()"><i  class="fa fa-fw fa-search-plus"></i></button>
    <button class="margin-operations-buttons" v-if="showUpload" @click="myCroppa.zoomOut()"><i  class="fa fa-fw fa-search-minus"></i></button>
    </div>
    <div class="div-btn-conf"><button class="button-upload" v-if="showUpload" @click="upload">{{ 'upload' | lang }}</button></div>
    <div> <p style='color:red' v-if="error">{{error}}</p></div>
   
    </div>
    </template>
    
    <script>
        
    import page from '@/mixins/routeControl'
    import UserServices from '@/mixins/services/userServices'
    import Vue from 'vue';
    import VueCroppie from 'vue-croppa';
    import 'vue-croppa/dist/vue-croppa.css';
    
    Vue.use(VueCroppie)
    export default {
      name: 'ProfileImage',
      mixins: [ UserServices, page ],
      data () {
        return {
          initialized:false,
          maxHeight:1000,
          minHeight:100,
          maxWidth:1000,
          minWidth:100,  
          quality:1.5,    
          myCroppa: {},
          error: null,
          height:300,
          width:300,
          fileSizeLimit:10000000,
          showUpload:false, 
          image:null
        }
      },
      methods: {
        upload() {
          this.dataUrl =   this.myCroppa.generateDataUrl('image/jpeg');
           this.myCroppa.generateBlob((blob) => {  
            let file = blob;
                        let allowedTypes = ['image/jpeg', 'image/png'];
                        this.error=null;   
                        if (!file) {
                            this.error=	this.dictValue('selectImage');
                            return;
                        }
                        file.size;
                        if (!allowedTypes.includes(file.type)) {
                            this.error = this.dictValue('wrongImageType');
                        }
                        if ((file.size / 1024)> this.fileSizeLimit) {
                            this.error=this.dictValue('fileTooLarge', null, { maxSize: this.fileSizeLimit });
                        }            
                        let image = new Image();
                        let reader = new FileReader();
                        reader.onload = (e) => {
                          image.src = e.target.result;
                          image.onload = () => {
                                if (image.width < this.minWidth || image.height < this.minHeight) {
                                    this.error =this.dictValue('fileTooLowResolution', null, { minSize: this.minHeight+'x'+this.minWidth });
                                }
                                if (image.width > this.maxWidth || image.height > this.maxHeight) {
                                    this.error =this.dictValue('fileTooHeightResolution', null, { maxSize: this.maxHeight+'x'+this.maxWidth  });
                                }
                                if (this.error == null) {                         
                                    let photo=reader.result.split('base64,',2)[1]
                                    this._setUserProfileImage (photo).then(() => {
                                      this.myCroppa.remove();
                                      this.image=reader.result;
                                    this.userProfile.profilo.Photo=reader.result;
                                   
                             }).catch(e => {      
                                this.image=reader.result;
                                this.myCroppa.remove();
                                  this.internalBus.$emit('notify:error', {
                                  text: this.dictValue('errorOccured') + (e.status === 418 ? '[VAD]' : ''),
                                  key: this.notifierKey,
                                  timeout: 3000
                                })        
                              })  
                                }
                            };
                        };
                        reader.readAsDataURL(file)
    
                               
           }, 'image/jpeg' ) 
         },
         getImage () {   
       
          this._getUserProfileImage().then((image) => {
            if(image!=null && image.Base64Data!=null)
            {
                this.image='data:image/jpeg;base64,'+image.Base64Data;
                this.userProfile.profilo.Photo=image.Base64Data;
                //this.showUpload=true;
            }  
          }).catch(e => {      
              console.error(e)
              this.internalBus.$emit('notify:error', {
              text: this.dictValue('errorOccured') + (e.status === 418 ? '[VAD]' : ''),
              key: this.notifierKey,
              timeout: 3000
            })         
          })
        },
         handleCroppaFileChoose()
         {
          console.log("handleCroppaFileChoose");
          this.showUpload=true;
         },
         handleCroppaMove()
         {
          console.log("handleCroppaMove");
         },
         handleCroppaFileSizeExceed()
         {
          this.error=this.dictValue('fileTooLarge', null, { maxSize: this.fileSizeLimit });
         },
         handleImageRemove()
         {
           console.log("handleImageRemove");
            this.showUpload=false;
            this.success=null;
            this.error=null;
         },
         handleCroppaZoom()
         {
           console.log("handleCroppaZoom");
         },
         handleCroppaFileTypeMismatch()
         {
            this.showUpload=false;
            this.error =	this.dictValue('wrongImageType');
         },

         setSize(width,height)
         {
          if(this.manifest.profileImage.maxHeight)
             this.maxHeight=this.manifest.profileImage.maxHeight;
          else
              this.maxHeight=this.manifest.profileImage.height*3;
              
          if(this.manifest.profileImage.minHeight)
             this.minHeight=this.manifest.profileImage.minHeight;
          else
            this.minHeight=this.manifest.profileImage.height/2;

          if(this.manifest.profileImage.maxWidth)
             this.maxWidth=this.manifest.profileImage.maxWidth;
          else
            this.maxWidth=this.manifest.profileImage.width*2;
         
          if(this.manifest.profileImage.minWidth)
             this.minWidth=this.manifest.profileImage.minWidth;
          else 
            this.minWidth=this.manifest.profileImage.width/2;

          this.fileSizeLimit=this.manifest.profileImage.fileSizeLimit;
          var maxWidth=300;
          this.quality = width/maxWidth;
          this.height=height/this.quality;
         }
    
       },
       mounted () {

        this.setSize(this.manifest.profileImage.width,this.manifest.profileImage.height);
       // this.getImage ();
        if(this.userProfile.profilo.Photo!=null)
        {
          if(!this.userProfile.profilo.Photo.startsWith('data:image/jpeg;base64,'))
             {this.image='data:image/jpeg;base64,'+this.userProfile.profilo.Photo;  
            }
          else
             {
              this.image=this.userProfile.profilo.Photo;      
             }     
        }
        this.initialized=true;
           
      },
    
    }
    </script>
    
    <style lang="scss">
    @import '@/assets/_vars.scss';
    
    
    .wrapper-img
    {
      width:300px;
      flex: none;
      margin: auto;
    }
    
    .wrapper-img:hover
    {
     opacity:1;
    }
    
    .button-upload{
      width:100%;
    }
    .div-btn-cond{
      margin: auto;
      text-align: center;
    }
    .placeholder-img
    {
      position: relative;
    color: white;
    z-index: 2;
    bottom: 40px;
    text-align: center;
    margin-left: 5px;
    width: 290px;
    margin-right: 5px;
    background: rgba(111, 138, 145, 0.5);
    }
    
    .spinner {
      position: absolute;
      top: 50%;
      left: 50%;
      height: 70px;
      width: 70px;
      margin-left: -35px;
      margin-top: -35px;
      -webkit-animation: spin 1s linear infinite;
              animation: spin 1s linear infinite;
      border: 3px solid #ddd;
      border-top: 3px solid #42a5f5;
      border-radius: 50%;
    }
    
    div.slots{

      display:none;
    }

    @-webkit-keyframes spin {
      to {
        border-top-color: #ec407a;
        -webkit-transform: rotate(360deg);
                transform: rotate(360deg);
      }
    }
    
    @keyframes spin {
      to {
        border-top-color: #ec407a;
        -webkit-transform: rotate(360deg);
                transform: rotate(360deg);
      }
    }
    
    .croppa-operations
    {
      text-align: center;
    }

    .margin-operations-buttons
    {
      margin: 0.8rem;
    }

    div.line  { 
      background-color: Blue; 
      height: 2px;  
      width: 100%;
  }

    </style>
    